module.exports = __webpack_public_path__ + "img/jujue_img.44cd6596.png";